/*
Fork addition: Captains of Industry build-menu categories, extracted from
the game data (captain-of-data machines_and_buildings.json, game v0.8.1.0).
Keys are the packaged short item keys (see data/coi/keys.json).
*/
export const COI_CATEGORY_ORDER: string[] = ["General", "Food production", "Basic", "Water extraction & processing", "Fluid", "Distillation", "Aluminum", "Nuclear", "Forestry", "Titanium", "Silicon", "Glass", "Iron", "Copper", "Gold", "Derivatives", "Solid", "Maintenance", "Cargo docks", "Buildings", "Vehicles", "Storage", "Housing & services", "Terraforming", "Settlement", "Rockets", "Data center"];

export const COI_ITEM_CATEGORY: Record<string, string> = {
 "b4": "General",
 "0": "General",
 "1": "General",
 "2": "General",
 "3": "General",
 "4": "General",
 "5": "General",
 "6": "General",
 "7": "General",
 "8": "General",
 "b5": "General",
 "6k": "Food production",
 "6p": "Food production",
 "6x": "Food production",
 "9": "Basic",
 "18": "Basic",
 "1a": "Water extraction & processing",
 "1c": "Fluid",
 "1e": "Water extraction & processing",
 "1g": "Water extraction & processing",
 "1i": "Distillation",
 "1m": "Distillation",
 "1u": "Distillation",
 "1w": "Water extraction & processing",
 "1A": "Water extraction & processing",
 "1E": "Water extraction & processing",
 "1I": "Water extraction & processing",
 "1K": "General",
 "2d": "General",
 "2o": "General",
 "2O": "General",
 "3h": "General",
 "3r": "General",
 "1M": "General",
 "1P": "General",
 "1S": "General",
 "4x": "Aluminum",
 "4A": "General",
 "eq": "General",
 "es": "General",
 "3A": "General",
 "3N": "General",
 "c0": "Water extraction & processing",
 "40": "Water extraction & processing",
 "44": "Food production",
 "48": "Nuclear",
 "4c": "Water extraction & processing",
 "4g": "Water extraction & processing",
 "4k": "Nuclear",
 "c8": "Nuclear",
 "4m": "Forestry",
 "4o": "Nuclear",
 "cf": "Nuclear",
 "4C": "Titanium",
 "4K": "Silicon",
 "4M": "Glass",
 "4T": "Glass",
 "eM": "Aluminum",
 "50": "Titanium",
 "52": "Iron",
 "54": "Aluminum",
 "57": "Aluminum",
 "eR": "Titanium",
 "5a": "Copper",
 "5d": "Iron",
 "5f": "Iron",
 "5h": "Glass",
 "5j": "Glass",
 "5l": "Aluminum",
 "5n": "Silicon",
 "5p": "Gold",
 "bh": "Food production",
 "1X": "Food production",
 "5s": "Titanium",
 "5D": "Derivatives",
 "5J": "Distillation",
 "5L": "Distillation",
 "5N": "Titanium",
 "5P": "Derivatives",
 "5V": "Distillation",
 "62": "Distillation",
 "64": "Distillation",
 "66": "Derivatives",
 "c": "Titanium",
 "k": "Titanium",
 "s": "Fluid",
 "D": "Derivatives",
 "M": "Fluid",
 "O": "Fluid",
 "10": "Solid",
 "bP": "Solid",
 "bH": "Forestry",
 "bB": "Solid",
 "S": "Solid",
 "3y": "Iron",
 "6f": "Maintenance",
 "6i": "Maintenance",
 "6c": "Maintenance",
 "69": "Maintenance",
 "9l": "Food production",
 "9Q": "Food production",
 "9R": "Food production",
 "9S": "Food production",
 "9Z": "Food production",
 "a0": "Buildings",
 "6D": "Buildings",
 "6C": "Buildings",
 "6B": "Buildings",
 "6A": "Buildings",
 "a1": "Storage",
 "a5": "Storage",
 "a9": "Storage",
 "ad": "Nuclear",
 "cI": "Nuclear",
 "6E": "Nuclear",
 "cK": "Nuclear",
 "6F": "Solid",
 "af": "Water extraction & processing",
 "6G": "General",
 "6H": "Data center"
};
